<template>
  <div class="allorder">
    <el-dialog
      :title="fastMailInfo.trackingNo ? $t('other.a2851') : $t('other.a142')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div v-if="!fastMailInfo.trackingNo">
        <span>{{ $t("other.a2850") }}</span>
      </div>
      <div v-if="fastMailInfo.trackingNo">
        <div>{{ $t("other.a594") }}：{{ fastMailInfo.logistics }}</div>
        <div>{{ $t("other.a896") }}：{{  fastMailInfo.trackingNo}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("other.a1552")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('other.a2852')"
      :visible.sync="dialogVisibleImg"
      width="30%"
    >
      <div class="waterWrapper">
        <div
          class="waterProduct"
          @click="openImg(item)"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img :src="item" v-show="item.indexOf('mp4') == -1" />
          <video :src="item" v-show="item.indexOf('mp4') != -1"></video>
          <div
            class="dexlet"
            @click="deleteWaterImg(item, index)"
            v-if="!LookStatus"
          >
            x
          </div>
        </div>
        <div v-if="!LookStatus">
          <el-upload
            action=""
            class="uploaImg"
            :http-request="uploaWaterImg"
            :show-file-list="false"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
      <div v-if="imageLength" class="okting">
        <el-progress
          :text-inside="true"
          :stroke-width="18"
          :percentage="percentage"
        ></el-progress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upFileData">{{
          $t("other.a1552")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleOpen" width="30%">
      <img :src="OpenItem" v-show="OpenItem.indexOf('mp4') == -1" />
      <video :src="OpenItem" v-show="OpenItem.indexOf('mp4') != -1"></video>
    </el-dialog>
    <div>
      <div style="font-size: 22px; margin: 10px 0">{{ $t("other.a2838") }}</div>
      <condition
        :ConditionOption="ConditionOption"
        @getOrderParams="getOrderParams"
      ></condition>
      <div class="condition_box">
        <div class="time_choose">
          <span style="margin-right: 20px">{{ $t("other.a2839") }}</span>
          <el-date-picker
            v-model="timeValue"
            type="datetimerange"
            size="small"
            value-format="yyyy-MM-dd"
            @change="gerOrder"
            :picker-options="pickerOptions2"
            :range-separator="rangeseparator"
            :start-placeholder="startplaceholder"
            :end-placeholder="endplaceholder"
            align="right"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="nodata" v-if="!allOrderList.length">
        <div v-if="orderstatus !== -1">--{{ $t("shippedorder.nodata") }}--</div>
        <div style="color: #606266" v-if="orderstatus == -1">
          {{ $t("allorders.notbound") }}
          <router-link
            style="color: red; text-decoration: none"
            :to="{ name: 'index' }"
            >{{ $t("allorders.shopx") }}</router-link
          >
        </div>
      </div>
      <div class="order-wrapper">
        <div
          class="order-list-item"
          v-for="(item, index) in allOrderList"
          :key="index"
        >
          <div class="list-desc">
            <span class="seller seller-item"
              >{{ $t("other.a2843") }}：<span class="seller-ppc">{{
                getTime(item.createTime)
              }}</span></span
            >
            <span class="seller seller-item"
              >{{ $t("shippedorder.status") }}：<span class="seller-ppc">{{
                getStatus(item.status)
              }}</span></span
            >
            <span class="seller seller-item"
              >{{ $t("other.a2844") }}：<span class="seller-ppc">{{
                item.userId
              }}</span></span
            >
            <span class="seller seller-item"
              >{{ $t("other.a2845") }}：<span class="seller-ppc">{{
                item.name
              }}</span></span
            >
            <span class="seller seller-item"
              >{{ $t("other.a519") }}：<span class="seller-ppc">{{
                item.phone
              }}</span></span
            >
            <el-button
              type="primary"
              @click="fastMail(item)"
              v-if="item.status > 1"
              >{{ $t("other.a2851") }}</el-button
            >
          </div>

          <div class="return-desc">
            <div class="return-item">
              <div class="return-wrpaer" style="flex: 1">
                <div
                  class="return-item-list"
                  :class="{ unfold: active !== index }"
                  v-for="ttp in item.items"
                >
                  <span class="pic-box"
                    ><img
                      v-image-preview
                      :src="
                        ttp.attributeImage ? ttp.attributeImage : ttp.image
                      "
                  /></span>
                  <div class="pic-box-desc">
                    <div class="pbOne">
                      <div>
                        {{ $t("other.a1251") }}：<span class="seller-ppc">
                          {{ ttp.variationName }}
                        </span>
                      </div>
                      <div>
                        {{ $t("other.a310") }}：<span class="seller-ppc">
                          {{ ttp.stock }}
                        </span>
                      </div>
                    </div>
                    <div class="pbTwo" v-if="ttp.status == 'REJECT'">
                      <div>
                        {{ $t("other.a2846") }}：<span class="seller-ppc">
                            {{ $t("other.a3228") }}
                        </span>
                      </div>
                      <div>
                        {{ $t("other.a2847") }}：<span class="seller-ppc">
                            {{ ttp.remark }}
                        </span>
                      </div>
                    </div>
                    <div class="pbTwo" v-if="ttp.status == 'NOPASS'">
                      <div>
                        {{ $t("other.a2848") }}：<span class="seller-ppc">
                          {{ $t("other.a3085") }}
                        </span>
                      </div>
                      <div>
                        {{ $t("other.a2849") }}：<span class="seller-ppc">
                          {{ ttp.remark }}
                        </span>
                      </div>
                    </div>
                    <div class="pbTwo" v-if="ttp.status == 'COMPLETE'">
                      <div style="color: #333">
                        {{ $t("other.a3175") }}
                      </div>
                    </div>
                      <div class="pbTwo" v-if="ttp.status == 'APPROVED'">
                        <div>
                          {{ $t("other.a2848") }}：<span class="seller-ppc">
                            {{ $t("other.a1406") }}
                          </span>
                        </div>
                      </div>  
                    <div class="pbBtn">
                      <el-button
                        type="primary"
                        v-if="(item.status==2&&ttp.status == 'APPROVED')||(item.status==2&&ttp.status == 'REJECT')"
                        @click="upFile(item, ttp)"
                        >{{ $t("other.a3239") }}</el-button
                      >
                      <el-button
                        type="primary"
                        v-if="ttp.status == 'TOBERETURNED'"
                        @click="LookImg(item, ttp)"
                        >{{ $t("other.a3176") }}，{{ $t("other.a2842") }}</el-button
                      >
                      <el-button
                        type="primary"
                        v-if="ttp.status == 'COMPLETE'"
                        @click="LookImg(item, ttp)"
                        >{{ $t("other.a3176") }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="allOrderList.length" class="Pager">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            :page-sizes="[15, 20, 30, 50]"
            :page-size="params.offset"
            layout="total, sizes, prev, pager, next, jumper"
            :total="allCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import api from "../../../api/api";
import orderApi from "../../../api/moudles/order";
import Condition from "../../../components/condition";
import utils from "../../../utils/utils.js";
export default {
  data() {
    return {
      imageLength: 0,
      percentage: 0,
      dialogVisible: false,
      dialogVisibleImg: false,
      imgList: [],
      fastMailInfo: {},
      description: this.$t("allorders.description"),
      setmeal: this.$t("allorders.setmeal"),
      itemnum: this.$t("allorders.item"),
      rangeseparator: this.$t("allorders.until"),
      startplaceholder: this.$t("allorders.starttime"),
      endplaceholder: this.$t("allorders.endtime"),
      searplaceholder: this.$t("allorders.lookup"),
      contentplar: this.$t("allorders.modified"),
      type: 0,
      shophasAuthorization: JSON.parse(
        localStorage.getItem("shophasAuthorization")
      ),
      allStoreIds: JSON.parse(localStorage.getItem("userInfo")).storeIds,
      allshopIdS: JSON.parse(localStorage.getItem("userInfo")).shopIds,
      offset: 15, //每页显示条数
      activeName: "first",
      currentPage1: 1,
      inputtext: "",
      all_shop: [],
      order_all: [],
      shopId: "",
      orderstatus: 0,
      active: -1,
      itemId: null,
      skuId: null,
      cusCode: null,
      timeValue: [],
      allShopInfo: [],
      pickerOptions2: {
        shortcuts: [
          {
            text: this.$t("allorders.latestweek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("allorders.Lastmonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("allorders.Lastthreemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ConditionOption: [
        {
          id: 0,
          desc: this.$t("other.a2840"),
          isActive: 0,
          list: [
            {
              label: this.$t("other.a730"),
              value: 1,
              active: false,
            },
            {
              label: this.$t("other.a2841"),
              value: 2,
              active: false,
            },
            {
              label: this.$t("other.a2842"),
              value: 3,
              active: false,
            },
            {
              label: this.$t("other.a119"),
              value: 5,
              active: false,
            },
          ],
        },
      ],
      params: {
        end: null,
        start: null,
        orderId: null,
        orderType: null,
        offset: 50,
        page: 0,
        status: 0,
        shopIds: null,
        storeIds: null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      allOrderList: [],
      allCount: 0,
      upItem: {},
      LookStatus: false,
      dialogVisibleOpen:false,
      OpenItem:''
    };
  },
  components: {
    Condition,
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      pendingorderCounts: (state) => state.order.pendingorderCounts,
      unprocessedorderCounts: (state) => state.order.unprocessedorderCounts,
    }),
    shippedorder() {
      return this.$t("shippedorder");
    },
    totalCount() {
      if (this.orderstatus === 0) {
        return this.allCount;
      } else if (this.orderstatus === 1) {
        return this.pendingorderCounts;
      } else if (this.orderstatus === 3) {
        return this.unprocessedorderCounts;
      } else if (this.orderstatus === 4) {
        return this.unprocessedorderCounts;
      } else if (this.orderstatus === 5) {
        return this.unprocessedorderCounts;
      }
    },
  },
  watch: {
    inputtext() {
      if (this.inputtext === "") {
        this.handleCurrentChange();
      }
    },
    params() {
      alert(123);
    },
  },
  created() {
    this.itemId = this.$route.query.itemId;
    this.skuId = this.$route.query.skuId;
    this.cusCode = this.$route.query.cusCode;
    this.init();
  },
  methods: {
    ...mapActions("order", [
      "getAllorder",
      "getOrdersBytrickNo",
      "getGoodsOrder",
    ]),
    upFileData() {
      if(this.LookStatus){
          this.dialogVisibleImg = false;
        return
      }
      
      if(this.imgList.length == 0){
        this.$message.warning(this.$t("other.a3243"));
        return
      }
      this.upItem.uploadUrl = this.imgList.join(",");
      api.freeApplyOrderUpload(this.upItem).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.imgList = [];
          this.dialogVisibleImg = false;
          this.queryAllOrder(this.params);
        }else{
              this.$message.warning(res.msg);
        }
      });
    },
    LookImg(item, ttp) {
      this.LookStatus = true;
      this.dialogVisibleImg = true;
      this.imgList = ttp.uploadUrl.split(",");
    },
    upFile(item, ttp) {
      this.upItem = {
        cusCode: ttp.cusCode,
        freeId: item.freeId,
        uploadUrl: "",
      };
      this.imgList = []
      console.log(item);
      this.LookStatus = false;
      this.dialogVisibleImg = true;
    },
    queryAllOrder(params) {
      console.log(params);
      api.freeApplyOrderQueryApplyOrders(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.allOrderList = res.data.freeApplyQueries;
          this.allCount = res.data.count;
        }
      });
    },
    uploaWaterImg(params) {
      console.log(params);
      const _file = params.file;

      let formData = new FormData();
      formData.append("file", _file);

      console.log("formData", formData);

      api.uploadImg(formData).then((res) => {
        if (res.code === 200) {
          console.log(res.data);
          this.imgList.push(res.data);
        }
      });
    },
    deleteWaterImg(item, index) {
      this.$confirm(this.$t("other.a608"), this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a235"),
        cancelButtonText: this.$t("other.a146"),
        type: "warning",
      }).then(() => {
        this.$message.success(this.$t("other.a565"));
        this.imgList.splice(index, 1);
      });
    },
    openImg(item) {
      this.dialogVisibleOpen = true
      this.OpenItem = item
    },
    fastMail(item) {
      console.log(item)
      this.dialogVisible = true;
      this.fastMailInfo = {
        logistics: item.logistics,
        trackingNo: item.trackingNo,
      };
    },
    getOrderParams(data) {
      console.log(data);
      this.currentPage1 = 1;
      this.params.page = 0;
      this.params.status = data[0].isActive;
      this.params.storeIds = this.allStoreIds;
      console.log(this.params);
      this.queryAllOrder(this.params);
    },

    gerOrder() {
      if (this.timeValue && this.timeValue.length > 0) {
        this.params.start = this.timeValue[0];
        this.params.end = utils.CurdateAddoneday(this.timeValue[1]);
      } else {
        this.params.start = null;
        this.params.end = null;
      }
      this.queryAllOrder(this.params);
    },

    init() {
      if (!this.shophasAuthorization) {
        return;
      }

      // this.timeValue = [
      //   utils.getRecentSevenDay(-30),
      //   utils.getRecentSevenDay(1),
      // ];
      console.log(this.all_shop);
      this.params.shopIds = this.allshopIdS;
      this.params.storeIds = this.allStoreIds;
      this.queryAllOrder(this.params);
    },

    //获取卖家帐号下所有的订单
    //控制每页显示订单条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.offset = parseInt(`${val}`);
      this.params.offset = parseInt(`${val}`);
      this.handleCurrentChange();
    },
    //显示当前第几页
    handleCurrentChange(val) {
      this.currentPage1 = parseInt(`${val}`);
      this.params.page = parseInt(`${val}`)
        ? (parseInt(`${val}`) - 1) * this.params.offset
        : 0;
      this.queryAllOrder(this.params);
    },

    getStatus(item) {
      const params = {
        0: this.$t("other.a730"),
        1: this.$t("other.a2841"),
        2: this.$t("other.a2842"),
        3: this.$t("other.a926"),
        4: this.$t("other.a119"),
      };
      let ttp = null;
      ttp = params[item];
      return ttp;
    },
    getTime(item) {
      return utils.renderTime(item);
    },
  },
};
</script>

<style >
.title-enter-active {
  transition: all 0.3s ease;
}

.title-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.title-enter, .title-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: scale(0.5);
  /* opacity: 0; */
}

.allorder {
  /* flex: 1;
		margin: 60px 0 0 235px; */
}

.allorder .time_choose {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}
.allorder .order-list-item {
  position: relative;
  padding-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.allorder .order-title,
.allorder .order-query {
  display: flex;
  justify-content: space-between;

  padding: 10px 0;
  border-bottom: 1px #E0E0E0 solid;
}

.allorder .order-query .query {
  position: relative;
  margin-right: 30px;
}

.allorder .list-btn {
  padding: 20px 15px;
}

.allorder .list-desc {
  margin-left: 15px;
  border-bottom: 1px #eee solid;
  padding: 10px 0px;
}

.allorder .list-desc-item {
  font-size: 14px;

  padding-right: 15px;
}

.allorder .list-item-status {
  color: red;
}

.allorder .didan {
  font-size: 24px;
}

.allorder .list-content {
  display: flex;
  justify-content: space-around;
  /* margin: 20px;
		padding: 20px; */
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
}

.allorder .order-pic {
  width: 80px;
  height: 80px;
}

img {
  width: 100%;
}

.allorder .list-content-left,
.allorder .list-content-right {
  display: flex;
}

.allorder .list-item-wrapper {
  box-sizing: border-box;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.allorder .order-selec {
  width: 150px;
  margin: 0 10px;
}
.allorder .block-ttp {
  width: 350px !important;
}
.allorder .order-desc {
  width: 30%;
}

.allorder .order-title-desc {
  margin-bottom: 15px;
}
.allorder .list-price-item,
.shoper-name {
  padding: 2px 0;
}
.allorder .list-number,
.list-price {
  margin-left: 40px;
}
.allorder .primary-btn {
  display: inline-block;
  margin: 0 30px;
}
.allorder .loading {
  position: absolute;
  z-index: 9999;
}

.allorder .second-menu {
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
}
.allorder .menu-right-btn {
  margin-right: 30px;
}
.allorder .second-menu-left {
  flex: 1;
  display: flex;
  padding: 0 10px;
}

.condition_box {
  padding-bottom: 5px;
  border-bottom: 1px solid #eeee;
}

.allorder .search-box {
  width: 100px;
  margin: 0 10px 0px 10px;
}
.allorder .order-wrapper {
  margin-top: 20px;
  margin-bottom: 80px;
}

.allorder .sousuo-box {
  width: 400px;
}

.allorder .chekbox {
  width: 30px;
  height: 30px;
}

.allorder .nodata {
  margin-top: 100px;
  text-align: center;
  color: #000;
}

.allorder .Pager {
  position: fixed;
  bottom: 0;
  left: 205px;
  right: 0;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: right;
}

.allorder .order-title-count {
  color: red;
  font-style: inherit;
  margin-left: 10px;
}
.allorder .logistics-header {
  font-size: 18px;
  margin-bottom: 10px;
}

/* 	新起点 */

.allorder .list-desc {
  display: flex;
  align-items: center;
  margin-left: 15px;
  border-bottom: 1px #eee solid;
}

.allorder .pendingorder .chekbox {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.allorder .pic-box {
  display: flex;
  margin: 2px;
  width: 80px;
  height: 80px;
}
.allorder .return-item {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 10px;
}
.allorder .return-item-list {
  display: flex;
  align-items: center;
}
.allorder .pic-box-desc {
  flex: 1;
  height: 80px;
  margin-left: 20px;
  display: flex;
  font-size: 16px;
  line-height: 24px;
  justify-content: space-between;
}
.allorder .pic-box-desc .pbOne {
  width: 320px;
  height: 100%;
}
.allorder .pic-box-desc .pbTwo {
  flex: 1;
  height: 100%;
  padding: 0px 20px;
  color: red;
}
.allorder .pic-box-desc .pbBtn {
  width: 320px;
  height: 100%;
}
.allorder .retrun-reasonr {
  margin-left: 30px;
}
.allorder .retrun-reasonr-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}
.allorder .seller {
  margin-right: 10px;
  font-size: 18px;
}
.allorder .return-reasonr-desc {
  box-sizing: border-box;
  padding: 3px 0;
}
.allorder .seller-item {
  margin-right: 15px;
  font-size: 16px;
}
.allorder .seller-ppc {
  color: red;
}

.allorder .img-box {
  display: flex;
}

.allorder .unfold:nth-of-type(n + 4) {
  display: none;
}
.waterWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-height: 300px;
  overflow-y: scroll;
  background-color: #eee;
}

.waterProduct {
  width: 90px;
  height: 90px;
  overflow: hidden;
  margin: 3px;
  cursor: pointer;

  border: 1px solid red;
}
.waterProduct img {
  width: 100%;
}
.uploaImg {
  border: 1px solid #000;
  width: 90px;
  height: 90px;
  margin: 3px;
}
</style>

<style lang="scss" scoped>
.waterWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-height: 300px;
  overflow-y: scroll;
  background-color: #eee;
}

.active {
  box-sizing: border-box;
  border: 3px solid #409EFF;
}

.waterProduct {
  width: 90px;
  height: 90px;
  overflow: hidden;
  margin: 3px;
  cursor: pointer;
  position: relative;

  .dexlet {
    position: absolute;
    right: 3px;
    top: 3px;
    width: 10px;
    height: 10px;
    text-align: center;
    line-height: 10px;
    background-color: #fff;
    padding: 5px;
    border-radius: 50px;
    color: #000;
  }

  img {
    width: 100%;
  }
}

.uploaImg {
  border: 1px solid #000;
  width: 90px;
  height: 90px;
  margin: 3px;
}

/deep/ .el-icon-plus {
  font-size: 25px;
  margin: 30px 0 0 30px;
}
</style>